/**
 * Centralized configuration for API endpoints and environment variables
 */

// Main backend API URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Google Maps configuration
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const GOOGLE_MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID || '';

// Google OAuth
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Firebase configuration
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Social integrations
export const WHATSAPP_PHONE_NUMBER = process.env.REACT_APP_WHATSAPP_PHONE_NUMBER || ''; // Verification number
export const CHAT_WHATSAPP_NUMBER = process.env.REACT_APP_CHAT_WHATSAPP_NUMBER || ''; // Support/Chat number
export const TELEGRAM_BOT_USERNAME = process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'your_bot';

// Mapbox configuration (Advanced Trip)
export const MAPBOX_API_KEY_ADVANCED = process.env.REACT_APP_MAPBOX_API_KEY_ADVANCED || '';

// Export consolidated config object
export const config = {
  apiBaseUrl: API_BASE_URL,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  googleMapId: GOOGLE_MAP_ID,
  googleClientId: GOOGLE_CLIENT_ID,
  firebase: FIREBASE_CONFIG,
  whatsappPhoneNumber: WHATSAPP_PHONE_NUMBER,
  chatWhatsappNumber: CHAT_WHATSAPP_NUMBER,
  telegramBotUsername: TELEGRAM_BOT_USERNAME,
  mapboxApiKeyAdvanced: MAPBOX_API_KEY_ADVANCED,
} as const;

